import React from "react";
import useWithStore from "@/Hooks/useWithStore";

const YourChoiceLayout = (props) => {
    const {
        value = '', onClick = () => {
        }
    } = props;

    return <div className={`yourChoice__item`}>
        <p>{value}</p>
        <div className={`yourChoice__cross cross`} onClick={onClick}></div>
    </div>
}

export default useWithStore(YourChoiceLayout);
